import { PlainTextContent } from "@shared-kernel/primary/shared/plain-text-content/plain-text-content.content";
import type { ObjectiveDetailVM } from "@academy-context/read/domain/types/shared/training-item-evaluation";
import type { OBJECTIVE_ACQUISITION_STATUS } from "@academy-context/read/domain/types/training-follow-up";
import { OBJECTIVE_STATUS_CONFIG } from "@academy-context/shared/domain/types/objective-status-config";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import { Badge } from "@components/ui/badge";

const ObjectiveIndexBadge = ({ index, isRated }: { index: number; isRated: boolean }) => (
  <Badge variant={isRated ? "default" : "secondary"} className="h-5 min-w-5 shrink-0 px-1.5 text-xs">
    {index + 1}
  </Badge>
);

interface Props {
  objective: ObjectiveDetailVM;
  index: number;
  selectedStatus: OBJECTIVE_ACQUISITION_STATUS | undefined;
  onSelectStatus: (status: OBJECTIVE_ACQUISITION_STATUS) => void;
}

// Un objectif du groupe : son intitulé et le statut que l'intervenant lui donne. Rien d'autre —
// l'appréciation porte sur la formation entière et se saisit une seule fois, en bas du formulaire.
export const ObjectiveRow = ({ objective, index, selectedStatus, onSelectStatus }: Props) => (
  <div className="flex items-start gap-3 rounded-lg border border-border bg-card p-4">
    <ObjectiveIndexBadge index={index} isRated={Boolean(selectedStatus)} />
    <div className="min-w-0 flex-1 space-y-3">
      <PlainTextContent content={objective.quantifiableObjective} className="text-sm" />
      <div className="flex flex-wrap gap-2">
        {OBJECTIVE_STATUS_CONFIG.map(config => {
          const isSelected = selectedStatus === config.value;
          return (
            <Badge
              key={config.value}
              variant="outline"
              onClick={() => onSelectStatus(config.value)}
              className={cn(
                "cursor-pointer select-none focus:outline-none",
                isSelected ? config.selectedClassName : config.unselectedClassName,
              )}
            >
              {config.label}
            </Badge>
          );
        })}
      </div>
    </div>
  </div>
);
